export const HAVE_QUESTION = 'mailto:team@yeypass.com?subject=I have a question'

export const passQuestion = (linkId) => {
  return `${HAVE_QUESTION} - Pass [Ref: ${linkId}]`
}

export const reviewAgreementQuestion = (linkId) => {
  return `${HAVE_QUESTION} - Review Agreement [Ref: ${linkId}]`
}

export const userDetailsQuestion = (linkId) => {
  return `${HAVE_QUESTION} - User Details [Ref: ${linkId}]`
}



// WEBPACK FOOTER //
// ./src/api/constants/Passes.js